module.exports = __webpack_public_path__ + "static/media/quarkus.dddd4846.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quarkus.svg
// module id = 530
// module chunks = 0